export const collator = new Intl.Collator(undefined, {
  caseFirst: "lower",
  numeric: true,
});
